import { render } from "./SprintTickets.vue?vue&type=template&id=d84ddef6&scoped=true"
import script from "./SprintTickets.vue?vue&type=script&lang=js"
export * from "./SprintTickets.vue?vue&type=script&lang=js"

import "./SprintTickets.vue?vue&type=style&index=0&id=d84ddef6&scoped=true&lang=css"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d84ddef6"]])

export default __exports__